class SkinLifeCarousel {
  constructor(carousel) {
    this.carousel = carousel;
    this.track = carousel.querySelector('[data-skinlife-track]');
    this.slides = Array.from(
      carousel.querySelectorAll('[data-skinlife-slide]')
    );
    this.previousButton = carousel.querySelector(
      '[data-skinlife-previous]'
    );
    this.nextButton = carousel.querySelector(
      '[data-skinlife-next]'
    );
    this.currentElement = carousel.querySelector(
      '[data-skinlife-current]'
    );
    this.totalElement = carousel.querySelector(
      '[data-skinlife-total]'
    );

    this.autoplayEnabled = carousel.dataset.autoplay === 'true';
    this.autoplayDelay =
      Number(carousel.dataset.autoplayDelay) || 4000;

    this.mobileQuery = window.matchMedia('(max-width: 749px)');
    this.autoplayTimer = null;
    this.scrollTimer = null;
    this.resumeTimer = null;
    this.isPaused = false;

    if (!this.track || this.slides.length === 0) return;

    this.init();
  }

  init() {
    if (this.totalElement) {
      this.totalElement.textContent = String(this.slides.length);
    }

    this.previousButton?.addEventListener('click', () => {
      this.pauseTemporarily();
      this.goToPrevious();
    });

    this.nextButton?.addEventListener('click', () => {
      this.pauseTemporarily();
      this.goToNext();
    });

    this.track.addEventListener(
      'scroll',
      () => {
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = window.setTimeout(
          () => this.updateCounter(),
          80
        );
      },
      { passive: true }
    );

    this.track.addEventListener(
      'touchstart',
      () => this.pauseTemporarily(),
      { passive: true }
    );

    this.track.addEventListener('pointerenter', () => {
      this.isPaused = true;
    });

    this.track.addEventListener('pointerleave', () => {
      this.isPaused = false;
    });

    this.mobileQuery.addEventListener?.('change', () => {
      this.updateCounter();

      if (this.mobileQuery.matches) {
        this.startAutoplay();
      } else {
        this.stopAutoplay();
      }
    });

    this.updateCounter();
    this.startAutoplay();
  }

  getCurrentIndex() {
    const trackRectangle = this.track.getBoundingClientRect();
    const isRtl =
      window.getComputedStyle(this.track).direction === 'rtl';

    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    this.slides.forEach((slide, index) => {
      const slideRectangle = slide.getBoundingClientRect();
      const distance = isRtl
        ? Math.abs(slideRectangle.right - trackRectangle.right)
        : Math.abs(slideRectangle.left - trackRectangle.left);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  scrollToSlide(index) {
    if (!this.mobileQuery.matches) return;

    const safeIndex =
      (index + this.slides.length) % this.slides.length;

    const targetPosition =
  targetSlide.offsetLeft -
  track.offsetLeft;

track.scrollTo({
  left: targetPosition,
  behavior: smooth ? 'smooth' : 'auto'
});
  }

  goToNext() {
    this.scrollToSlide(this.getCurrentIndex() + 1);
  }

  goToPrevious() {
    this.scrollToSlide(this.getCurrentIndex() - 1);
  }

  updateCounter() {
    if (this.currentElement) {
      this.currentElement.textContent = String(
        this.getCurrentIndex() + 1
      );
    }
  }

  startAutoplay() {
    if (
      !this.mobileQuery.matches ||
      !this.autoplayEnabled ||
      this.slides.length < 2 ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      return;
    }

    this.stopAutoplay();

    this.autoplayTimer = window.setInterval(() => {
      if (!this.isPaused && !document.hidden) {
        this.goToNext();
      }
    }, this.autoplayDelay);
  }

  stopAutoplay() {
    if (!this.autoplayTimer) return;

    window.clearInterval(this.autoplayTimer);
    this.autoplayTimer = null;
  }

  pauseTemporarily() {
    this.isPaused = true;
    window.clearTimeout(this.resumeTimer);

    this.resumeTimer = window.setTimeout(() => {
      this.isPaused = false;
    }, 5000);
  }
}

function initializeSkinLifeCarousels(container = document) {
  const carousels = container.querySelectorAll(
    '[data-skinlife-carousel]:not([data-skinlife-initialized])'
  );

  carousels.forEach((carousel) => {
    carousel.dataset.skinlifeInitialized = 'true';
    new SkinLifeCarousel(carousel);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeSkinLifeCarousels();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeSkinLifeCarousels(event.target);
});
